import { useCustomTheme } from "contexts/theme";
import React, { Fragment } from "react";

const MailConnectorSVG = () => {
  const {
    theme: { setup },
  } = useCustomTheme();

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.667 3.33301H3.33366C2.41699 3.33301 1.66699 4.08301 1.66699 4.99967V14.9997C1.66699 15.9163 2.41699 16.6663 3.33366 16.6663H16.667C17.5837 16.6663 18.3337 15.9163 18.3337 14.9997V4.99967C18.3337 4.08301 17.5837 3.33301 16.667 3.33301ZM16.3337 6.87467L10.8837 10.283C10.342 10.6247 9.65866 10.6247 9.11699 10.283L3.66699 6.87467C3.45866 6.74134 3.33366 6.51634 3.33366 6.27467C3.33366 5.71634 3.94199 5.38301 4.41699 5.67467L10.0003 9.16634L15.5837 5.67467C16.0587 5.38301 16.667 5.71634 16.667 6.27467C16.667 6.51634 16.542 6.74134 16.3337 6.87467Z"
        fill="#3300FF"
      />
    </svg>
  );
};

export default MailConnectorSVG;
